module.exports = __webpack_public_path__ + "static/20200119_152857_optimized-9ac0ac3fc797517b2937b62ea257673c.jpg";